// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { headerStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerStyles.tagText = {
    css: css`
        display: flex;
        background: ${getColor("primary.main")};
        color: ${getColor("primary.contrast")};
        border: 1px solid ${getColor("primary.main")};
        &:hover {
            background: ${getColor("common.white")};
            color: ${getColor("primary.main")};
        }
        white-space: nowrap;
        margin-right: 6px;
        margin-bottom: 6px;
        padding: 2px 6px;
        font-size: ${fontConfig.fontSize.regular}px;
        align-items: center;
        padding-left: 14px;
        svg {
            width: 14px;
            height: 14px;
        }
    `,
};
